// extracted by mini-css-extract-plugin
export default {"box":"sidebar-section_box__AekBO","divider":"sidebar-section_divider__t8zbn"};